/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_Search_PlaceholderInputs */

const cs_documents_search_placeholder = /** @type {(inputs: Documents_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Název souboru nebo složky (min. 2 znaky)`)
};

const en_documents_search_placeholder = /** @type {(inputs: Documents_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File or folder name (min. 2 characters)`)
};

/**
* | output |
* | --- |
* | "File or folder name (min. 2 characters)" |
*
* @param {Documents_Search_PlaceholderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_search_placeholder = /** @type {((inputs?: Documents_Search_PlaceholderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Search_PlaceholderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_search_placeholder(inputs)
	return cs_documents_search_placeholder(inputs)
});